var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 381,
    height: 497,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 499,
    width: 383,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "#ac4b1c",
    d: "m378.765025,61.110897l-99.339,0l0,-19.868c0,-21.943 -17.792,-39.736 -39.736,-39.736l-99.339,0c-21.944,0 -39.736,17.793 -39.736,39.736l0,19.868l-99.339,0l0,19.868l20.47,0l19.887,377.489c0,21.944 17.792,39.736 39.736,39.736l218.546,0c21.944,0 39.736,-17.792 39.736,-39.736l19.538,-377.489l19.577,0l0,-19.868l-0.001,0zm-258.282,-19.868c0,-10.962 8.926,-19.868 19.868,-19.868l99.339,0c10.962,0 19.868,8.906 19.868,19.868l0,19.868l-139.075,0l0,-19.868zm199.338,416.196l-0.039,0.505l0,0.524c0,10.943 -8.906,19.868 -19.868,19.868l-218.546,0c-10.942,0 -19.868,-8.925 -19.868,-19.868l0,-0.524l-0.019,-0.523l-19.848,-376.442l297.669,0l-19.481,376.46z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_3",
    y: 120.713897,
    x: 180.086025,
    width: 19.868,
    height: 317.885,
    fill: "#ac4b1c"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_4",
    points: "140.79684448242188,437.95987260341644 120.46383666992188,120.69588029384613 100.63484191894531,121.9558824300766 120.96884155273438,439.21988236904144 ",
    fill: "#ac4b1c"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_5",
    points: "279.56182861328125,121.3348878622055 259.73284912109375,120.09388291835785 239.68984985351562,437.9788850545883 259.5188293457031,439.21988236904144 ",
    fill: "#ac4b1c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove-icon.7897c6665e6f488575df751b329c4916.svg";
export { ForwardRef as ReactComponent };